import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'kentima';
const args = {};

export class Kentima extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
